import {ConvertTypeTransformConf} from '@tj/tj-dmp-lib-api';

export type I18nConversionField = 'key' | 'value' | 'countryCode' | 'cityCode' | 'code' | 'iso' | 'dial_code';
export type I18nConversionLanguage = 'FR' | 'EN' | 'IT' | 'DE' | 'NL' | 'ES';
export type I18nConversionNoMatch = 'ERROR' | 'EMPTY' | 'KEEP_SOURCE';

/** API contract shared with common-lib. The group determines supported fields. */
export interface I18nConversionConfig {
    group: string | null;
    matchField: I18nConversionField | null;
    resultField: I18nConversionField | null;
    language?: I18nConversionLanguage;
    onlyEnabled: boolean;
    onNoMatch: I18nConversionNoMatch;
}

/** Extend the generated client model with the dedicated conversion API contract. */
export interface I18nConversionTransformConf extends ConvertTypeTransformConf {
    i18nConversion?: I18nConversionConfig;
}

export interface I18nConversionFieldOption {
    value: I18nConversionField;
    label: string;
    translated?: boolean;
}

export interface I18nConversionGroup {
    value: string;
    label: string;
    fields: I18nConversionFieldOption[];
    defaultMatchField: I18nConversionField;
    languages: I18nConversionLanguage[];
    requiresLanguage: boolean;
}

export interface I18nConversionPreview {
    source: string;
    result: string | null;
    status: 'MATCH' | 'NOT_FOUND' | 'AMBIGUOUS' | 'MISSING_RESULT';
}

export function emptyI18nConversion(): I18nConversionConfig {
    return {group: null, matchField: null, resultField: null, onlyEnabled: false, onNoMatch: 'ERROR'};
}
